<template>
    <div class="main-container w-full h-full flex column align-center p-20 border-box ">
        <div class=" w-full h-full flex column content-item">
            <AdminTable v-if="loaded"
                header='Templates' 
                :headers="[
                    // { key: 'id', name: 'ID' },
                    { key: 'filename', name: 'Name' , format: (val) => val ? 'YES' : 'NO'},
                    { key: 'label', name: 'Label'},
                    { key: 'type', name: 'Type' },
                    { key: 'enabled', name: 'Enabled', format: (val) => val ? 'Yes' : 'No' },
                    { key: 'created_at', name: 'Created At', format: (val) => val ? Utils.renderTime(val) : 'N/A' },
                    { key: 'order', name: 'order'  },
                ]"
                :data="mergedData"
                @row-click="handleRowClick"
            />
        </div>
        <PopupCover v-if="activeTemplate" @close="closePopup">
            <PopupBody @close="closePopup" style="width: 500px">
                <template #header>
                    Template Details - {{ activeTemplate.type }}
                </template>
                <template #body>
                    <div class="template-popup-body flex column gap-10">
                        <InpComponent
                            label="label"
                            class="bg-white"
                            :value="activeTemplate.label || ''"
                            type="text"
                            @inputChange="activeTemplate.label = $event[1]"
                        />
                        <InpComponent
                            label="order"
                            class="bg-white"
                            :value="activeTemplate.order"
                            type="number"
                            @inputChange="activeTemplate.order = $event[1]"
                        />
                        <Toggle
                            :value="activeTemplate.enabled"
                            :options="[
                                { label: 'Enabled', value: true },
                                { label: 'Disabled', value: false },
                            ]"
                            @change="(val) => activeTemplate.enabled = val"
                            :label="'Status'"
                        />  
                        <Toggle
                            :value="activeTemplate.available_on_signup"
                            :options="[
                                { label: 'Enabled', value: true },
                                { label: 'Disabled', value: false },
                            ]"
                            @change="(val) => activeTemplate.available_on_signup = val"
                            :label="'Available on signup'"
                        />  
                        
                      
                        <div v-if="activeTemplate.filename" class="flex column gap-5px align-start">
                            <div class="bold">Current Template:</div>
                            <div class='attachment w-full border-box' 
                                >
                                <img src="@/assets/excel-file.svg" class='fileicon'>
                                <div class="filename">
                                    <div class="name-of-the-file">{{ activeTemplate.filename }}</div>
                                    <div class="size-of-the-file">{{ Utils.calculateFileSize(activeTemplate.filesize) }}</div>
                                </div>
                                <div class="flex-1 flex justify-end p-10 pointer">
                                    <img class='download' 
                                        @click="downloadTemplate()" src="@/assets/download.svg"> 
                                </div>
                            </div>
                        </div>
                        <div v-else class="w-full text-left">
                            No template file uploaded yet
                        </div>
                        <div v-if="activeTemplate.filename && !showReplace" class="button-section flex gap-10">
                            <button class="button" @click="showReplace = true">Replace Template</button>
                        </div>

                        <MultiFileUploader v-if="showReplace || !activeTemplate.filename" type=".xlsx" :single=true @sendFileInfo="getFiles" class="uploadfile" />
                        <div class="text-left bold">Description</div>
                        <CommentSection
                            class="comment-section"
                            :commentSection="activeTemplate.structure"
                            @changeinput="quillContent" 
                        />
                        <div class="button-section flex gap-10 mt-40">
                            <button class="button transparent" @click="closePopup">Cancel</button>
                            <button class="button" :disabled="!saveAvailable" @click="saveChanges()">Save</button>
                        </div>
                    </div>
                </template>
            </PopupBody>
        </PopupCover>
    </div>
</template>

<script setup>
    import BO_API from '../api/bo_api.js'
    import API from '@/api/index.js';
    import { ref, onMounted, computed } from 'vue';
    import { FIUTemplatesTypes } from '../../../shared/index';
    import AdminTable from '@/components/AdminTable.vue';
    import PopupBody from '@/components/PopupBody.vue';
    import InpComponent from '@/components/InpComponent.vue';
    import CommentSection from '@/views/CommentSection.vue';
    import PopupCover from '@/components/PopupCover.vue';
    import MultiFileUploader from '@/components/MultifileUploader.vue';
    import Toggle from '@/elements/Toggle.vue';
    import store from '../store/index.js';
    import Utils from '@/utils/index.js';



    const templates = ref([]);
    const mergedData = ref([]);
    const loaded = ref(false);
    const activeTemplate = ref(null);
    const selectedFile = ref(null);
    const initialState = ref(null);
    const showReplace = ref(false);

    const saveAvailable = computed(() => {
        if (!activeTemplate.value) return false;
        const currentState = JSON.stringify(activeTemplate.value);
        const initial = JSON.stringify(initialState.value.find(item => item.type === activeTemplate.value.type));
        if (selectedFile.value) {
            return true;
        }
        return currentState !== initial;
        
    });

    onMounted(async () => {
        try {
            const response = await BO_API.loadTemplates();
            templates.value = response.templates;
            formatTemplateData();
        } catch (error) {
            console.error('Error fetching templates:', error);
        }
    });
    function getFiles(files) {
        selectedFile.value = files[0];
    }

    async function downloadTemplate(){
        await API.downloadTemplate(activeTemplate.value.type, activeTemplate.value.filename);
    }
    function quillContent(event) {
        activeTemplate.value.structure = event.structure;
        activeTemplate.value.content = event.text;
    }
    function formatTemplateData() {
        Object.keys(FIUTemplatesTypes).forEach(type => {
            const template = templates.value.find(t => t.type === type);
            if( template ){
                console.log('Found template for type:', template.order, template.type);
                mergedData.value.push({
                    filename: template.filename,
                    enabled: template.enabled,
                    type: type,
                    filesize: template.filesize,
                    created_at: template.created_at,
                    available_on_signup: template.available_on_signup,
                    order: template.order || 100,
                    label: template.label || null,
                    structure: template.structure || null,
                });
                if (template.structure) {
                    mergedData.value[mergedData.value.length - 1].structure = JSON.parse(template.structure);
                }
            } else {
                mergedData.value.push({
                    filename: null,
                    enabled: false,
                    type: type,
                    order: 100,
                    created_at: null,
                    available_on_signup: false,
                    label: null,
                    structure: null
                });
            }
        });
        mergedData.value.sort((a, b) => a.order - b.order);
        initialState.value = JSON.parse(JSON.stringify(mergedData.value));
        loaded.value = true
    }
    function handleRowClick(item) {
        activeTemplate.value = JSON.parse(JSON.stringify(item));
    }
    function closePopup() {
        activeTemplate.value = null;
        selectedFile.value = null;
    }
    async function saveChanges(){
        const templateData = {
            label: activeTemplate.value.label,
            type: activeTemplate.value.type,
            enabled: activeTemplate.value.enabled,
            available_on_signup: activeTemplate.value.available_on_signup,
            order: activeTemplate.value.order,
            structure: activeTemplate.value.structure ? JSON.stringify(activeTemplate.value.structure) : null,
            content: activeTemplate.value.content || null,
        }

        let templateResponse = await BO_API.uploadTemplateFile(selectedFile.value, templateData);
        const templateResp = templateResponse.template;
        activeTemplate.value = {
            id: templateResp._id,
            filename: templateResp.filename,
            enabled: templateResp.enabled,
            label: templateResp.label,
            filesize: templateResp.filesize,
            type: activeTemplate.value.type,
            created_at: templateResp.created_at,
            available_on_signup: templateResp.available_on_signup,
            order: templateResp.order,
        }
        mergedData.value = mergedData.value.map(item => {
            if (item.type === activeTemplate.value.type) {
                return {
                    filename: templateResp.filename,
                    enabled: templateResp.enabled,
                    filesize: templateResp.filesize,
                    type: templateResp.type,
                    label: templateResp.label,
                    created_at: templateResp.created_at,
                    available_on_signup: templateResp.available_on_signup
                };
            }
            return item;
        });
        showReplace.value = false;
        selectedFile.value = null;
        activeTemplate.value = null;

        if (templateResponse.status === 'success') {
            store.dispatch('addNotification', { type: 'success', text: 'Template updated successfully' });
        } else {
            store.dispatch('addNotification', { type: 'error', text: 'Failed to update template' });
        }
       
    }
    


</script>


<style scoped lang="scss">
    .content-item {
        padding: 20px;
        
    }
    .table-header {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 20px;
        text-align: left;
    }
    .filename {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.message-attachments {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
.size-of-the-file {
    font-size: 0.8rem;
    color: rgb(116 119 127);
}
.name-of-the-file {
    display: flex;
    align-items: center;
    color: black;
    font-size: 0.9rem;

    text-align: left;
    overflow: hidden;
    text-wrap: nowrap;
    text-overflow: ellipsis;
}
.template-popup-body {
    max-height: 80vh;
    overflow-y: auto;
}
.fileicon {
    width: 40px;
    height: 40px;
}

.attachment {
    border-radius: .5rem;
    border-width: 1px;
    -moz-column-gap: .5rem;
    column-gap: .5rem;
    grid-template-columns: fit-content(100%) 1fr;
    border-color: rgb(224 226 236);
    background-color: rgb(255 255 255);
    padding: .8rem;


    display: flex;
    align-items: center;
}
.comment-section {
    height: 200px;
    &:deep(.editor-section) {
        height: 70vh;
    }
}

</style>